export function formatStringUnits(count, unitWords) {
    // Определяем последние цифры числа
    const lastDigit = count % 10;
    const lastTwoDigits = count % 100;

    // Исключения для чисел 11-14
    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return `${count} ${unitWords[2]}`;
    }

    // Для остальных случаев
    if (lastDigit === 1) {
        return `${count} ${unitWords[0]}`;
    } if (lastDigit >= 2 && lastDigit <= 4) {
        return `${count} ${unitWords[1]}`;
    }
    return `${count} ${unitWords[2]}`;
}
